@file:OptIn(InternalResourceApi::class)

package duomaproducao.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/duomaproducao.composeapp.generated.resources/"

@delegate:ResourceContentHash(470_159_096)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(78_891_592)
internal val Res.drawable.duo_logo: DrawableResource by lazy {
      DrawableResource("drawable:duo_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/duo_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_347_572_101)
internal val Res.drawable.icon: DrawableResource by lazy {
      DrawableResource("drawable:icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_013_044_874)
internal val Res.drawable.icon_svg: DrawableResource by lazy {
      DrawableResource("drawable:icon_svg", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_svg.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("duo_logo", Res.drawable.duo_logo)
  map.put("icon", Res.drawable.icon)
  map.put("icon_svg", Res.drawable.icon_svg)
}
